import cn from 'classnames'
import React, { ComponentProps } from 'react'

export type ReceiptRulesUpsellSvgProps = {
  className?: string
} & ComponentProps<'svg'>
export default function ReceiptRulesUpsellSvg(
  props: ReceiptRulesUpsellSvgProps,
) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('ReceiptRulesUpsellSvg', className)}
      width="192"
      height="179"
      viewBox="0 0 192 179"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_18702_103913)">
        <rect
          x="8.13965"
          y="17.3284"
          width="93.42"
          height="17.46"
          fill="#1E3150"
          fillOpacity="0.15"
        />
        <path
          d="M156.562 150.348V158.992C156.562 165.548 151.662 170.864 145.617 170.864H104.8V170.868H39.0713C33.0232 170.868 28.1201 165.552 28.1201 158.994V150.348H156.562Z"
          fill="#1E3150"
          fillOpacity="0.15"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.4248 1.34974C9.60939 -0.641369 3.80284 8.09755 4.00511 27.5665H75.3828"
          fill="#BFDEF3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.0225 1.02105C21.1364 0.158253 23.1934 6.98934 23.1934 21.5143C23.1934 35.3625 23.1934 88.4062 23.1934 144.041C23.1934 149.579 25.6606 152.324 30.595 152.275L134.735 152.348C139.446 152.348 141.801 149.273 141.801 143.125C141.801 136.976 141.801 96.439 141.801 21.5143C141.801 7.90663 136.595 1.10278 126.185 1.10278C115.774 1.10278 79.3865 1.07554 17.0225 1.02105Z"
          fill="#223C66"
        />
        <rect
          x="45.8867"
          y="50.5814"
          width="74.9301"
          height="7.00905"
          rx="2.35162"
          fill="white"
        />
        <rect
          x="45.8867"
          y="69.4387"
          width="74.9301"
          height="7.00905"
          rx="2.35162"
          fill="white"
        />
        <rect
          x="45.8867"
          y="88.2965"
          width="74.9301"
          height="7.00905"
          rx="2.35162"
          fill="white"
        />
        <rect
          x="45.8867"
          y="107.153"
          width="50.3984"
          height="7.00905"
          rx="2.35162"
          fill="white"
        />
        <path
          d="M23.1946 142.059V150.702C23.1946 157.259 28.0905 162.574 34.1299 162.574H151.71C145.667 162.574 140.766 157.262 140.754 150.702V142.059H23.1946Z"
          fill="#223C66"
        />
        <path
          d="M162.593 142.059V150.702C162.593 157.259 157.693 162.574 151.649 162.574H33.9707C40.0184 162.574 44.9243 157.262 44.9355 150.702V142.059H162.593Z"
          fill="#BFDEF3"
        />
        <g filter="url(#filter1_d_18702_103913)">
          <ellipse
            cx="144.956"
            cy="92.2627"
            rx="39.0444"
            ry="39.0442"
            fill="url(#paint1_linear_18702_103913)"
          />
        </g>
        <path
          d="M125.546 79.0567H131.658"
          stroke="white"
          strokeWidth="2.393"
          strokeLinecap="round"
        />
        <path
          d="M140.103 78.9847H164.395"
          stroke="white"
          strokeWidth="2.393"
          strokeLinecap="round"
        />
        <path
          d="M158.737 92.1666H164.395"
          stroke="white"
          strokeWidth="2.393"
          strokeLinecap="round"
        />
        <path
          d="M147.864 106.196H164.394"
          stroke="white"
          strokeWidth="2.393"
          strokeLinecap="round"
        />
        <path
          d="M125.546 92.1666H150.76"
          stroke="white"
          strokeWidth="2.393"
          strokeLinecap="round"
        />
        <path
          d="M125.546 106.053H139.325"
          stroke="white"
          strokeWidth="2.393"
          strokeLinecap="round"
        />
        <rect
          x="150.76"
          y="88.3217"
          width="7.81051"
          height="7.79694"
          rx="2.393"
          stroke="white"
          strokeWidth="2.393"
        />
        <rect
          x="139.324"
          y="102.304"
          width="7.81051"
          height="7.79694"
          rx="2.393"
          stroke="white"
          strokeWidth="2.393"
        />
        <rect
          x="132.279"
          y="75.0924"
          width="7.81051"
          height="7.79694"
          rx="2.393"
          stroke="white"
          strokeWidth="2.393"
        />
        <path
          d="M46.5335 37.8919C47.5507 39.3886 49.6359 40.0305 51.4888 39.4175C53.3418 38.8044 54.433 37.1116 54.0821 35.3945C53.7312 33.6774 52.0384 32.4268 50.0593 32.4224V32.4224C48.0695 32.4265 46.3622 31.1735 46.0062 29.4477C45.6502 27.722 46.7478 26.0193 48.6118 25.4056C50.4758 24.792 52.5708 25.4437 53.585 26.9528"
          stroke="white"
          strokeWidth="3.4992"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M49.9355 39.4325V42.6725"
          stroke="white"
          strokeWidth="3.0672"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M49.9355 21.2883V24.5283"
          stroke="white"
          strokeWidth="3.0672"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter1_d_18702_103913"
          x="98.4111"
          y="44.7185"
          width="93.0889"
          height="93.0884"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-1" />
          <feGaussianBlur stdDeviation="3.75" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18702_103913"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_18702_103913"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint1_linear_18702_103913"
          x1="175"
          y1="64.0007"
          x2="114.5"
          y2="121.501"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00D0B4" />
          <stop offset="1" stopColor="#4186F6" />
        </linearGradient>
        <clipPath id="clip0_18702_103913">
          <rect
            width="188"
            height="171"
            fill="white"
            transform="translate(4)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
